module.exports = __webpack_public_path__ + "img/Miles Long.72c2c806.png";